import {Component, OnInit} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {QARService, SODClashEntity} from '../services/qar.service';
import {AppUser} from '../framework/AppUser';
import {UITableComponent} from '../framework/ui/table';


@Component({
	selector: 'app-page-sod-clashes',
	templateUrl: './sod-clashes.html',
	providers: [QARService]
})

export class SODClashesComponent implements OnInit {

	constructor(public api: QARService, public user: AppUser) {
	}

	public isSuperApprover = false;
	public self = this;

	ngOnInit(): void {
		this.isSuperApprover = this.user.hasGroup('SUPER_APPROVERS');
		this.clashes_init();
	}

	public clashes = {
		chunker: new Chunker([]),
		chunkedData: [],
		uploadedFiles: [],
		loading: false,
		selected: new SODClashEntity(),
		tableOptions: {
			refreshButton: true,
			onRefreshContext: this,
			onRefreshFunction: () => {
				this.clashes_init();
			}
		},
		headers: [
			{id: 'oi1', label: 'User First Name', sortable: true, idFunction: this.idFunctionUserFirstName, filterable: true},
			{id: 'uln', label: 'User Last Name', sortable: true, idFunction: this.idFunctionUserLastName, filterable: true},
			{id: 'sys1', label: 'System 1', sortable: true, filterable: true, idFunction: this.idFunctionSystem1},
			{ud: 'strn1', label: 'Role 1 Name', sortable: true, filterable: true, idFunction: this.idFunctionStandardRoleName1},
			{id: 'sys2', label: 'System 2', sortable: true, filterable: true, idFunction: this.idFunctionSystem2},
			{id: 'strn2', label: 'Role 2 Name', sortable: true, filterable: true, idFunction: this.idFunctionStandardRoleName2},
			{id: 'Age', label: 'Age (days)', sortable: true, filterable: true},
			{
				id: 'StatusId',
				label: 'Status',
				sortable: true,
				filterable: true,
				filterValue: 'keepItHere, overriden later',
				type: 'dropdown',
				options: {choices: {pending: 'Pending & Expired', accepted: 'Approved'}},
				idFunction: this.idFunctionStatus
			}
		]
	};

	public idFunctionStatus(d) {
		if (d.StatusId === 'clashing' || d.StatusId === 'expired') {
			return 'pending';
		}
		return 'accepted';
	}

	public idFunctionUserFirstName(d) {
		return d.SORUser?.FirstName;
	}

	public idFunctionUserLastName(d) {
		return d.SORUser?.LastName;
	}


	public idFunctionSystem1(d) {
		return d.SODClashDefinition.SystemRole1.System.Name;
	}

	public idFunctionSystem2(d) {
		return d.SODClashDefinition.SystemRole1.System.Name;
	}

	public idFunctionStandardRoleName1(d) {
		return d.SODClashDefinition.SystemRole1.MappedName;
	}

	public idFunctionStandardRoleName2(d) {
		return d.SODClashDefinition.SystemRole2.MappedName;
	}

	public daysToDate(d) {
		const currenttime = new Date().getTime();
		const datetime = new Date(d.ReinstatedDate ? d.ReinstatedDate : d.DateCreated).getTime();
		const ret = Math.floor((currenttime - datetime) / (60 * 60 * 24 * 1000)) +1;
		return ret;
	}

	public clashes_init() {
		this.clashes.loading = true;
		this.api.retrieveSODClashes().then(r => {
			for (const k in r) {
				r[k]['Age'] = this.daysToDate(r[k]);
			}
			this.clashes.chunker = new Chunker(r);
			this.clashes.chunkedData = r;
			this.clashes.loading = false;
			this.clashes.headers[7].filterValue = 'pending';
		}, e => {
			this.clashes.loading = false;
			this.alert('Sorry, something went wrong, please reload the page');
		});
	}

	public clash = {
		notes: [],
		loading: false,
		addingNote: false,
		chunker: new Chunker([]), // {} is only so that the table does not show the "table is empty"
		newNote: {message: null, decision: 'note', exceptionValidUntil: null}
	};

	public clash_select(clash) {
		this.clashes.selected = clash;
		this.clash.loading = true;
		this.clash.newNote.message = '';
		this.clash.newNote.decision = 'note';
		this.clash_load_notes();
		this.clashes.uploadedFiles = [];
	}


	uploadAcceptsFile(file) {
		console.log('uploadAcceptsFile', file);
		const reader = new FileReader();
		reader.readAsDataURL(file); // alternatively you can use readAsDataURL

		reader.onloadend = (evt: ProgressEvent) => {
			console.log('uploadAcceptsFile loaded', evt);
		};
		reader.addEventListener('load', () => {
			// convert image file to base64 string
			console.log(reader.result);
			this.clashes.uploadedFiles.push(file.name + '||||||' + reader.result);
		}, false);

		return true;
	}

	public clash_load_notes() {
		this.clash.notes = [];
		this.clash.loading = true;
		this.api.retrieveSODClashNotes(this.clashes.selected.Id).then(r => {
			this.clash.loading = false;
			this.clash.notes = r;
		}, e => {
			this.clash.loading = false;
			this.alert('Sorry, something went wrong, please reload the page');
		});
	}

	public clash_add_note() {
		if (this.clash.newNote.decision === 'accept' && !this.clash.newNote.exceptionValidUntil) {
			this.alert('Date "exception until" cannot be blank', 'Warning');
		} else if (!this.clash.newNote.message || this.clash.newNote.message.length < 3) {
			this.alert('Notes cannot be blank. Please enter a valid Note and press Apply in order to proceed', 'Warning');
		} else {
			this.clash.addingNote = true;
			this.api.addNoteToSODClash(this.clashes.selected.Id, this.clash.newNote.message, this.clash.newNote.decision, this.clashes.uploadedFiles, this.clash.newNote.exceptionValidUntil).then(r => {
				this.clash.addingNote = false;
				this.clash_load_notes();
				// apply
				if (this.clash.newNote.decision === 'accept') {
					for (const clash in this.clashes.chunkedData) {
						console.log('this.clashes.chunkedData[clash]', this.clashes.chunkedData[clash]);
						if (this.clashes.chunkedData[clash].Id === this.clashes.selected.Id) {
							console.log('update');
							this.clashes.chunkedData[clash].StatusId = 'accepted';
						}
					}
				}
				this.clash.newNote.message = '';
				this.clash.newNote.exceptionValidUntil = null;
				this.clash.newNote.decision = 'note';
			});
		}
	}

	public alert(text, title = 'Warning') {
		this.modalAlert.display = true;
		this.modalAlert.title = title;
		this.modalAlert.text = text;
		this.modalAlert.cb = (yesorno) => {
			this.modalAlert.display = false;
		};
	}

	public modalAlert = {
		display: false,
		title: '',
		text: '',
		cb: (yesorno) => {
		}
	};

	public attachmentsAsArray(note): AttachmentsAsArrayItem[] {
		if (!note.Attachments) {
			return [];
		}
		const ret = [];
		const atts = note.Attachments.split('||||||');
		for (let i = 0; i < atts.length; i += 2) {
			ret.push({base64: atts[i + 1], name: atts[i]});
		}
		return ret;
	}

	public hasAttachments(note) {
		return note.Attachments && note.Attachments.split('||||||').length > 0;
	}

	public downloadAttachment(attr) {
		const a = document.createElement('a'); //Create <a>
		a.href = '' + attr.base64; //Image Base64 Goes here
		a.download = attr.name; //File name Here
		a.click(); //Downloaded file
		a.remove();
	}

}

export class AttachmentsAsArrayItem {
	public name;
	public base64;
}
